<template>
    <div class="footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col-6 text-left">
                    Copyright © GBSDC Lda,   {{ year }} | All Rights Reserved.
                </div>
                <div class="col-6 text-right">
                    <a href="#">Terms and Conditions</a>
                </div>
            </div>
         </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
        data () {
            return {
                year: new Date().getFullYear()
            }
        }
    }
</script>

<style lang="scss">
$orange: #f26522;
$white: #FFF;

.footer{
    padding:25px;
    background: darken($orange, 10);
    color:$white;
    font-size: 14px;
}
</style>
